<template>
    <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden">
        <template slot="modal-header">
            {{ Translations.buttons.createClock }}
        </template>
        <template>
            <b-form class="form" @submit.prevent="createClock">
                <input type="hidden" id="stationUid" name="stationUid" v-model="clockData.stationUid" />
                <div class="linked-properties">
                    <b-form-group id="group-name" :label="Translations.labels.name" label-for="name" :label-cols="4">
                        <b-form-input autofocus id="name" name="name" v-model="clockData.name" type="text" required autocomplete="off" :placeholder="Translations.placeholders.name" />
                    </b-form-group>
                    <b-form-group id="color-container" :label="Translations.labels.color" label-for="colorCode" :label-cols="4">
                        <b-form-input id="name" name="colorCode" v-model="clockData.colorCode" type="color" :placeholder="Translations.placeholders.color" />
                    </b-form-group>
                </div>
            </b-form>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="cancelModal" >{{ Translations.buttons.cancel }} </Button>
            <Button :empty="false" class="validate" :disabled="!isFormValid" @click.prevent="createClock">{{ Translations.buttons.doCreateClock }} </Button>
        </template>
    </b-modal>
</template>
<script>
    import Button from'@/components/common/Button'
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import Translations from '@/store/translations';
    import router from '@/router';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import { mapState } from 'vuex';
    import { HTTP } from "@/utils/http";

    export default {
        name: "ClockCreationCard",
        store, router,
        components: { Portlet, Bootstrap, Button },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            isFormValid() {
                const { name } = this.clockData;
                return name && name.trim().length;
            }
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                },
                clockData: {
                    stationUid: this.$store.state.currentStationUid,
                    name: "",
                    colorCode: "#ff6a00",
                }
            }
        }
        , methods: {
            cancelModal() { this.$refs['modal'].hide() },
            createClock() {
                if (this.isFormValid) {
                    HTTP.post("api/clocks/create", this.clockData)
                        .then(this.onClockCreated, this.onClockCreationError)
                        .then(function () {
                        });
                }
            },
            onClockCreated(response) {
                this.creationResponse = response;
                if (this.creationResponse.status === 200) {
                    const newItem = this.creationResponse.data;
                    if (newItem != null && newItem.dataItem != null) {
                        router.push({ name: 'ClockDetails', params: { clockUid: newItem.dataItem.uid } });
                        store.dispatch('loadStationClocks', this.currentStation.uid);
                        this.cancelModal();
                    }
                }
                else {
                    //let vue build the error messages
                }
            },
            onClockCreationError(response) {
                console.log(response);
                this.creationResponse = response;
                console.error(response);
            },
            onModalHidden() { EventBus.$emit('onClockCreationEnded'); }
        }
    }
</script>
<style>
</style>
